import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './VideosCrumb.module.scss';

const VideosCrumb: React.FC = () => {
	const { deleteVideoFromRestaurant, videos } = useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	return (
		<div className={style.container} data-test="VideosCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="videosLabel"
					size="s"
					weight="bold"
				/>
				{videos.map((restaurant, i) => {
					const isAnyVideoSelected = !!restaurant.videos.length;

					return (
						<div key={restaurant.restaurantId} data-test={`item-${i}`}>
							{isAnyVideoSelected && (
								<Text
									className={style.sectionName}
									translationKey={restaurant.restaurantAddress}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{restaurant.videos.map((video) => {
									return (
										<SelectedItemForBreadcrumbs
											key={video.videoId}
											label={video.videoName || ''}
											onDelete={() =>
												deleteVideoFromRestaurant(restaurant.restaurantId, video.videoId)
											}
										/>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default VideosCrumb;
